import "./Erro.css"

const Erro = () => {

    return(
        <div className="container_erro">
            <div>
                <h1> Erro - 404</h1>
                <p>Não existe essa rota por favor volte a pagina inicial</p>
            </div>
        </div>
    )
}

export default Erro;